var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('Profile',{attrs:{"ContactId":_vm.id}}),_c('v-container',{attrs:{"fluid":""}},[_c('Invoices',{attrs:{"ContactId":_vm.id,"hideCreate":"true"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }